import React from 'react';
import { Text, Dimensions, View, TouchableOpacity } from 'react-native-web';
import { withRouter } from 'react-router-dom';

import { JOURNEY_GET_THUMBNAIL} from "../api/journeyEndpoints";
import { Button, Card, ImageDisplay } from "../../../components";
import Colors from "../../../constants/Colors";


const JourneyComponent = (props) => {

    const { title, description, id } = props.data;
    const { height, width } = Dimensions.get('window');

    return(

        <TouchableOpacity
            style={{ width: 100, marginLeft: 12, marginRight: 12,  }}
            onPress={() => props.history.push('/journey/details', {journeyId: id})}
        >
            <ImageDisplay
                imageUrl={JOURNEY_GET_THUMBNAIL(id)}

                propsContainerStyle={{ height: 100, width: 100, borderRadius: 8 }}
                propsImageStyle={{ height: 100, width: 100, borderRadius: 8 }}

                resizeMode={'cover'}
            />

            <Text style={{ textAlign: 'center', fontSize: 14, marginBottom: 8, color: Colors.fontColorOnBackground }}>
	            { title }
            </Text>

        </TouchableOpacity>

    )
}

export default withRouter(JourneyComponent);
